import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/modal";

import type { ImpactLine } from "../types";

/** The impact of an edit, as the server counted it, awaiting confirmation. */
export function ImpactDialog({
  lines,
  stale,
  isPending,
  onConfirm,
  onCancel,
}: {
  lines: ImpactLine[];
  stale: boolean;
  isPending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Modal title={t("catalogue.impact.title")} onClose={onCancel} className="max-w-lg">
      <div className="space-y-3 p-4 text-sm">
        {stale && (
          <p
            role="alert"
            className="rounded-md border border-warning/30 bg-warning/10 px-3 py-2 text-warning-ink"
          >
            {t("catalogue.impact.stale")}
          </p>
        )}
        <p>{t("catalogue.impact.intro")}</p>
        <ul className="list-disc space-y-1 pl-5" data-impact-lines>
          {lines.map((line) => (
            <li key={line.code}>{line.label}</li>
          ))}
        </ul>
      </div>
      <div className="flex justify-end gap-2 border-t border-border p-4">
        <Button variant="outline" onClick={onCancel}>
          {t("catalogue.cancel")}
        </Button>
        <Button onClick={onConfirm} disabled={isPending}>
          {t("catalogue.impact.confirm")}
        </Button>
      </div>
    </Modal>
  );
}
